import { Fonts } from '../../../utils/resources/fonts';
import { Colors } from '../../../utils/resources/colors';
import { ButtonCSSStyleImpl } from '../button/buttoncss';

export class ReplaceButtonCSSStyleImpl extends ButtonCSSStyleImpl
{ 
    getWrapperCSSStyle(): object 
    {
       return {
        position: 'relative', 
        height: '31px', 
        width: '100%', 
        cursor: "default",
        outline:'none'

      };
    }

    getButtonStyle(): object 
    {
       return {
        width:'100%',
        height: '31px',
        float: 'left', 
        borderRadius: '3px',
        overflow: 'hidden',
        backgroundColor: this.getResources().getColor(Colors.color_36),
        cursor: "pointer",
        border: 'none',
        alignContent: 'center',
        alignItems: "center",
        justifyContent: "center",
        paddingTop: "3px",
        outline:'none'

      };
    }

    getButtonText(): object 
    {
        return {
            color: this.getResources().getColor(Colors.color_38), 
            fontSize: this.getResources().getFont(Fonts.h6), 
            fontFamily: this.getResources().getFontFamily(), 
            lineHeight: "20px",
            textAlign: "center",
            height: "20px",
            // width: "118px",
            // textTransform: "uppercase",
            cursor: "pointer"
       };
     } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/dragdropfile/replacebuttoncss.ts